<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 14:52:00
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-17 15:00:13
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\material\index.vue
 * @Descripttion:
-->
<template>
  <div class="list">
    <el-card>
      <condition-search ref="search" :query-items="queryItems" :search-param="searchParam" @search="handleSearch"
                        @reset="reset"></condition-search>
    </el-card>
    <div style="width: 100%;display: flex;">
      <el-card style="width: 280px; margin-right: 12px !important">
        <el-tree ref="tree" :data="categoryData" style="max-height: 80vh; overflow: auto" node-key="id"
                 :props="{ children: 'children', label: 'materialGroupName' }" :expand-on-click-node="false"
                 default-expand-all
                 highlight-current @node-click="handleCategoryClick">
          <el-tooltip slot-scope="{ node,data }" :disabled="showTitle" effect="dark" :content="tooltipTitle"
                      placement="top">
            <div style="display: flex;width: 100%;">
              <div class="span-ellipsis"
                   :style="{ width: categoryInfo.materialGroupId === data.materialGroupId && data.materialGroupId !== '0' ? '60%' : '100%' }"
                   @mouseover="onShowNameTips">
                {{
                  node.label
                }}
              </div>
              <div v-if="categoryInfo.materialGroupId === data.materialGroupId && data.materialGroupId !== '0'"
                   class="operate">
                <el-button type="text" @click="handleEditCatogery($event, data)">
                  <i class="el-icon-edit blue"></i>
                </el-button>
                <el-button type="text" @click="handleRemoveCatory($event, data)">
                  <i class="el-icon-delete red"></i>
                </el-button>
              </div>
            </div>
          </el-tooltip>
        </el-tree>
        <div style="text-align: center;">
          <el-button v-if="$btnsPermission('material:class')" class="add-button" plain @click="() => { categoryShow = true; categoryInfo = {} }">新增分类
          </el-button>
        </div>
      </el-card>
      <el-card style="flex: 5">
        <div style="margin-bottom: 12px;">
          <!-- v-if="$btnsPermission('materialManage:add')" -->
          <el-button v-if="$btnsPermission('material:add')" size="mini" type="primary" @click="handleAdd">
            添加物料
          </el-button>
          <!-- v-if="$btnsPermission('materialManage:import')" -->
          <el-button v-if="$btnsPermission('material:import')" type="primary" size="mini" @click="handleImport">
            导入物料
          </el-button>
          <!-- v-if="btnsPermission('materialManage:batchBind')" -->
          <el-button v-if="$btnsPermission('material:batchBind')" size="mini" :disabled="multipleSelection.length === 0" type="primary" @click="handleBatchBind">
            批量绑定DI
          </el-button>
          <!-- v-if="btnsPermission('materialManage:batchRemove')" -->
          <el-button v-if="$btnsPermission('material:batchRemove')" size="mini" :disabled="multipleSelection.length === 0" type="primary"
                     @click="handleBatchRemoveBind">
            批量解除绑定
          </el-button>
        </div>
        <el-table ref="table" v-loading.fullscreen="loading" :height="heightStyleObj" :data="listData" border stripe
                  @select="handleSelectionChange" @select-all="handleSelectAll"  @sort-change="handleSortChange($event)"
                  :default-sort="{ prop: 'materialCode', order: 'ascending' }"
        >
          <el-table-column type="selection" width="40"/>
          <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
            <template slot-scope="{ $index }">
              {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="materialName" sortable="custom" label="物料名称" width="150" show-overflow-tooltip/>
          <el-table-column prop="materialCode"  sortable="custom" label="物料编码" width="105" show-overflow-tooltip/>
          <el-table-column prop="specification" sortable="custom" label="物料规格型号" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="diCode" label="DI码" width="150" show-overflow-tooltip/>
          <el-table-column min-width="160" prop="packLevel" show-overflow-tooltip label="包装层级"/>
          <el-table-column prop="productName" label="产品名称" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="productSpecification" label="产品规格型号" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="description" label="描述" show-overflow-tooltip min-width="100"/>
          <el-table-column prop="updateBy" label="更新人" width="80" show-overflow-tooltip/>
          <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip width="150">
            <template slot-scope="{ row }">
              {{ row.updateTime ? parseTime(row.updateTime) : null }}
            </template>
          </el-table-column>
          <el-table-column label="状态" show-overflow-tooltip width="100">
            <template slot-scope="{ row }">
              <div :class="row.diId ? 'green' : 'orange'">{{ row.diId ? '已绑定' : '未绑定' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="180" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" @click="goDetail('查看物料详情', row)">查看</el-button>
              <el-button v-if="$btnsPermission('material:edit')" type="text" @click="handleEdit(row)">
                编辑
              </el-button>
              <el-button  v-if="row.diId && $btnsPermission('material:relieve')" type="text" @click="handleRemoveBind(row)">
                解除绑定
              </el-button>
              <!-- 未绑定DI状态才显示 -->
              <template v-if="!row.diId">
                <el-button type="text" @click="handleBind(row)">
                  绑定
                </el-button>
                <el-button type="text" @click="handleRomove(row)">
                  删除
                </el-button>
              </template>

            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total > 0" :total="total" :page-sizes="[10, 20, 50, 100]" :page.sync="searchParam.pageNum"
                    :limit.sync="searchParam.pageSize" @pagination="getList"/>
      </el-card>
    </div>
    <MaterailDetail v-if="detailShow" :material-data="materialData" :visible="detailShow" :page-title="pageTitle"
                    @close="close"/>
    <DISelect v-if="bindDialog" :visible="bindDialog" @getData="getData" @update:loading="loading = $event"
              @close="close"/>
    <MaterailBatchBind v-if="batchBindDialog" :visible="batchBindDialog" :material-data-list="multipleSelection"
                       @update:loading="loading = $event" @close="close"/>
    <addOrEdit v-if="addShow" :visible="addShow" :material-data="materialData" @close="close"></addOrEdit>
    <addOrEditCategory v-if="categoryShow" :category-info="categoryInfo" :category-data="categoryData"
                       :visible="categoryShow" @close="catoryClose"></addOrEditCategory>
    <importMaterial v-if="importShow" :visible="importShow" @close="close"></importMaterial>
  </div>
</template>

<script>
import {
  removeMaterialBind,
  materialBind,
  getMaterial,
  getMaterialCategory,
  removeMaterialCategory
} from '@/api/material'
import MaterailDetail from './components/detail'
import DISelect from './components/DISelect.vue'
import {handleTree} from '@/utils/ruoyi.js'
import {getDict} from '@/api/common/index'
import MaterailBatchBind from './components/batchBind'
import addOrEdit from './components/addOrEdit'
import importMaterial from './components/import'
import addOrEditCategory from './components/addOrEditCategory'
import {deleteSupervisor} from "../../api/antiFake/supervisor";
import {removeMaterial} from "../../api/material";

export default {
  // import引入的组件需要注入到对象中才能使用
  name: 'MaterialList',
  components: {MaterailDetail, importMaterial, DISelect, MaterailBatchBind, addOrEdit, addOrEditCategory},
  data() {
    // 这里存放数据
    return {
      loading: false,
      categoryInfo: {},
      categoryShow: false,
      bindDialog: false,
      detailShow: false,
      addShow: false,
      importShow: false,
      showTitle: false,
      batchBindDialog: false,
      materialData: {},
      tooltipTitle: null,
      total: 0,
      pageTitle: '查看物料详情',
      searchParam: {
        pageNum: 1,
        pageSize: 10,
        dateTime: [],
        keyword: null,
        isDi: '',
        materialGroupCode: null,
        isAsc: 'asc',
        orderByColumn: 'material_code'
      },
      multipleSelection: [],
      queryItems: [
        {
          label: '关键字搜索',
          field: 'keyword',
          placeholder: '物料名称/物料编码/物料规格型号/DI码',
          width: '300px',
          type: 'input',
        },
        {
          label: '是否绑定DI',
          field: 'isDi',
          type: 'select',
          options: [
            {dictLabel: '全部', dictValue: '-1'},
            {dictLabel: '已绑定', dictValue: '1'},
            {dictLabel: '未绑定', dictValue: '0'}
          ]
        },
        {
          label: '更新时间',
          field: 'dateTime',
          type: 'date',
        },
      ],
      heightStyleObj: 0,
      sortState: {}, // 记录每一列的排序状态
      sortProps: [], // 用于存储排序的列和顺序
      dictsObj: {
        material_check_status: [],
      },
      listData: [{}], // 列表数据
      categoryData: [], // 分类数据
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.heightStyleObj = window.innerHeight - 385 + 'px'
    this.getList()
    this.getMaterialCategory()
    this.getDict(['material_check_status'])
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    handleSortChange(sort) {
      const {order} = sort

      switch (sort.prop) {
        case 'materialName':
          this.searchParam.orderByColumn = 'material_name'
          break
        case 'materialCode':
          this.searchParam.orderByColumn = 'material_code'
          break
        case 'specification':
          this.searchParam.orderByColumn = 'specification'
          break
        default:
          this.searchParam.orderByColumn = 'material_code'

      }
      if (order === 'descending') {
        this.searchParam.isAsc = 'desc'
      }else if (order === null){
        this.searchParam.isAsc = null
        this.searchParam.orderByColumn = 'material_code'
      } else {
        this.searchParam.isAsc = 'asc'
      }

      this.handleSearch()
    },

    getDict(list) {
      list.forEach((dictType) => {
        getDict({dictType}).then((res) => {
          this.dictsObj[dictType] = res.rows
        })
      })
    },
    // 编辑物料分组
    handleEditCatogery($event, data) {
      $event.stopPropagation();
      this.categoryInfo = data
      this.categoryShow = true
    },
    // 绑定DI
    handleBind(row) {
      this.bindDialog = true
      this.materialData = row
    },
    // 删除物料
    handleRomove(row) {
      this.$confirm(`删除后无法恢复，您确定要删除${row.materialName}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        removeMaterial(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    catoryClose() {
      this.categoryShow = false
      this.reset()
      this.getMaterialCategory()
    },
    // 弹窗绑定确认
    getData(data) {
      const obj = {}
      obj.diId = data.id
      obj.diCode = data.code
      obj.materialCode = this.materialData.materialCode
      obj.packLevel = data.packLevel
      obj.description = data.description
      obj.id = this.materialData.id
      this.loading = true
      materialBind([obj])
        .then(() => {
          this.$message.success("绑定成功")
          this.close()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 删除物料分组
    handleRemoveCatory(e, data) {
      e.stopPropagation()
      this.$confirm('您确定删除当前分组？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const {id} = data
        removeMaterialCategory(id).then(() => {
          this.getMaterialCategory()
        })
      })
    },
    // 获取物料分组
    getMaterialCategory() {
      getMaterialCategory({}).then((res) => {
        res.data.unshift({
          materialGroupId: '0',
          parentMaterialGroupId: '',
          materialGroupName: '全部'
        })
        this.categoryData = handleTree(res.data, 'materialGroupId', 'parentMaterialGroupId')
      })
    },
    // 搜索按钮点击
    handleSearch() {
      this.searchParam.pageNum = 1
      this.getList()
    },
    // 处理全选
    handleSelectAll(val) {
      this.multipleSelection = val.length > 0 ? JSON.parse(JSON.stringify(this.listData)) : []
    },
    // 处理单选
    handleSelectionChange(val, row) {
      const findIndex = this.multipleSelection.findIndex((item) => item.id === row.id)
      if (findIndex !== -1) {
        this.multipleSelection.splice(findIndex, 1)
      } else {
        this.multipleSelection.push(row)
      }
    },
    /**
     * @description: 重置筛选条件
     * @return {*}
     */
    reset() {
      this.categoryInfo = {}
      this.searchParam = Object.assign(
        this.$data.searchParam,
        this.$options.data.call(this)
      ).searchParam
      this.$refs.tree.setCurrentKey(null)
      this.getList()
    },

    // 树形阶段超出显示。。。
    onShowNameTips(e) {
      const {target} = e
      const textLength = target.clientWidth
      const containerLength = target.scrollWidth
      console.log(textLength < containerLength, textLength, containerLength);
      if (textLength < containerLength) {
        this.tooltipTitle = e.target.innerText
        this.showTitle = false
      } else {
        this.showTitle = true
      }
    },

    // 分类点击查询
    handleCategoryClick(data) {
      this.searchParam.materialGroupCode = data.materialGroupCode
      this.categoryInfo = data
      this.getList()
    },
    // 解除绑定
    handleRemoveBind(row) {
      this.$confirm('您确定要解除已绑定的DI嘛？', '解除绑定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const {id, diCode, materialCode, diId} = row
        this.removeBind([{id, diCode, materialCode, diId}])
      })
    },
    // 解除绑定
    removeBind(list) {
      this.loading = true
      removeMaterialBind(list)
        .then(() => {
          this.$message.success('解除绑定成功')
          this.getList()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 批量解除绑定
    handleBatchRemoveBind() {
      if (this.multipleSelection.some((item) => !item.diCode)) {
        this.$message.error('所选数据中存在未绑定DI的物料，不能批量解除绑定！')
        return
      }
      this.$confirm(
        `已选择「${this.multipleSelection.length}」个产品<br/>您确定要批量解除已绑定的DI嘛？`,
        '批量解除绑定',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }
      ).then(() => {
        const list = this.multipleSelection.map(({diCode, diId, materialCode, id}) => {
          return {diCode, diId, materialCode, id}
        })
        this.removeBind(list)
      })
    },
    // 批量绑定DI
    handleBatchBind() {
      if (this.multipleSelection.some((item) => item.diCode)) {
        this.$message.error('所选数据中存在已绑定DI的物料，不能再次绑定！')
      } else {
        this.batchBindDialog = true
      }
    },
    // 导入物料
    handleImport() {
      this.importShow = true
    },
    // 查看详情
    goDetail(title, row) {
      this.detailShow = true
      this.pageTitle = title
      this.materialData = row
    },
    // 添加物料
    handleAdd() {
      this.addShow = true
    },
    // 编辑物料
    handleEdit(row) {
      this.materialData = JSON.parse(JSON.stringify(row))
      this.addShow = true
    },
    // 关闭详情
    close() {
      this.detailShow = false
      this.bindDialog = false
      this.addShow = false
      this.batchBindDialog = false
      this.importShow = false
      this.materialData = {}
      this.getList()
    },
    // 获取物料列表数据
    getList() {
      this.multipleSelection = []
      this.loading = true // 打开遮罩
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.dateTime) {
        const [startTime, endTime] = searchParam.dateTime
        searchParam.startTime = startTime
        searchParam.endTime = endTime
        delete searchParam.dateTime
      }
      getMaterial(searchParam)
        .then((res) => {
          // 判断是否懒加载数据
          this.listData = this.isLazy ? res.rows.slice(0, process.env.VUE_APP_LAZY_COUNT) : res.rows
          this.lazyList = res.rows.slice(process.env.VUE_APP_LAZY_COUNT)
          if (this.isLazy) {
            this.$nextTick(() => {
              this.$refs.table.bodyWrapper.scrollTop = 0
            })
          }
          this.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>

.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
}

body #app .operate ::v-deep .el-button {
  width: 40%;
  padding: 0 !important;
}

body #app .operate ::v-deep .el-button:hover {
  border: none !important;
  border-radius: none;
  background-color: none;
}
</style>

<style>
.el-table .warning-row td {
  background: #f8ecda !important;
  color: red;
}

.add-button {
  background: #fff !important;
  color: #0144bb !important;
  border: 1px dashed #0144bb !important;
  min-width: 160px;
  text-align: center;
  padding: 0 15px !important;
  margin: 24px 0 0;
}
</style>
